import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "components/bootstrap";
import ModalSubmit from "components/common/ModalSubmit";
const ConfirmDialog = ({
  btnConfirmDisabled = false,
  btnConfirmText = void 0,
  children,
  hideCancelButton = false,
  isAsyncSubmit = void 0,
  isSubmitting = void 0,
  onCancel = () => {
  },
  onConfirm,
  show = false,
  submitLoadingText = void 0,
  title
}) => {
  const { t } = useTranslation("common");
  const confirmText = btnConfirmText != null ? btnConfirmText : t("actions.confirm");
  const onHide = hideCancelButton ? onConfirm : onCancel;
  const submit = hideCancelButton ? /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      autoFocus: true,
      onSubmit: onConfirm,
      submitButtonType: "button",
      disabledSubmit: btnConfirmDisabled,
      submitButtonText: confirmText
    }
  ) : /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      autoFocus: true,
      disabledSubmit: btnConfirmDisabled,
      displayCancel: true,
      isAsyncSubmit,
      isSubmitting,
      onCancel,
      onSubmit: onConfirm,
      submitButtonText: confirmText,
      submitButtonType: "button",
      submitLoadingText
    }
  );
  return /* @__PURE__ */ React.createElement(Modal, { show, onHide, isConfirmDialog: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, title)), /* @__PURE__ */ React.createElement(Modal.Body, null, children), /* @__PURE__ */ React.createElement(Modal.Footer, null, submit));
};
export default ConfirmDialog;
